/**
 * Loads section scripts when the section enters (or nears) the viewport.
 */
(function () {
  'use strict';

  var designMode = document.documentElement.classList.contains('shopify-design-mode');

  function loadScript(src) {
    if (!src || document.querySelector('script[src="' + src + '"]')) return;

    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  }

  function loadScripts(urls) {
    urls.forEach(loadScript);
  }

  function runWhenIdle(fn, timeoutMs) {
    if (designMode) {
      fn();
      return;
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: timeoutMs || 3000 });
    } else {
      setTimeout(fn, timeoutMs || 3000);
    }
  }

  function parseUrls(raw) {
    return raw
      .split(',')
      .map(function (url) {
        return url.trim();
      })
      .filter(Boolean);
  }

  function init() {
    var sections = document.querySelectorAll('[data-lazy-section-scripts]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var urls = parseUrls(section.getAttribute('data-lazy-section-scripts') || '');
      if (!urls.length) return;

      if (designMode) {
        loadScripts(urls);
        return;
      }

      var rect = section.getBoundingClientRect();
      if (rect.height === 0 && rect.width === 0) {
        runWhenIdle(function () {
          loadScripts(urls);
        }, 2500);
        return;
      }

      if (!('IntersectionObserver' in window)) {
        runWhenIdle(function () {
          loadScripts(urls);
        }, 1500);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadScripts(urls);
            observer.disconnect();
          });
        },
        { rootMargin: '200px 0px' }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
